$(document).ready(() => {
  window.localStorage.setItem('harald_time_and_location', JSON.stringify([]));
  window.localStorage.setItem('harald_products', JSON.stringify([]));
  $('.form-tab').hide();
  $('#step-1').show();
});

$(document).ready(() => {
  $('#step-2 .back-button').on('click', () => {
    changeIndex(1);
  });
  $('#step-4 .back-button').on('click', () => {
    changeIndex(2);
  });
  $('#step-5 .back-button').on('click', () => {
    changeIndex(4);
  });
  $('#step-6 .back-button').on('click', () => {
    changeIndex(2);
  });
});


$(document).ready(() => {
  $('.payment-container input[type=radio]').change(function () {
    if (this.id == 'email-invoice') {
      $('.bill-email-container').removeClass('hidden');
      $('.e-invoice-inputs').removeClass('hidden');
      $('.operator-inputs').addClass('hidden');


      $('.bill-email-container input').each(function () {
        $(this).prop('required', true);
      });

      $('.e-invoice-inputs input').each(function () {
        $(this).prop('required', true);
      });

      $('.operator-inputs input').each(function () {
        $(this).prop('required', false);
      });
    } else if ((this.id == 'on-spot') || (this.id == 'send-payment-info-later')) {
      $('.bill-email-container').addClass('hidden');
      $('.e-invoice-inputs').addClass('hidden');
      $('.operator-inputs').addClass('hidden');

      $('.bill-email-container input').each(function () {
        $(this).prop('required', false);
      });

      $('.e-invoice-inputs input').each(function () {
        $(this).prop('required', false);
      });

      $('.operator-inputs input').each(function () {
        $(this).prop('required', false);
      });
    } else if (this.id == 'e-invoice') {
      $('.bill-email-container').addClass('hidden');
      $('.e-invoice-inputs').removeClass('hidden');
      $('.operator-inputs').removeClass('hidden');


      $('.operator-inputs input').each(function () {
        $(this).prop('required', true);
      });

      $('.bill-email-container input').each(function () {
        $(this).prop('required', false);
      });

      $('.e-invoice-inputs input').each(function () {
        $(this).prop('required', true);
      });
    }
  });
});

$('.amount-button').on('click', (event) => {
  var $button = $(event.currentTarget);
  var oldValue = $button.parent().find('input').val();
  var newVal = 0;

  if ($button.text() == '+') {
    newVal = parseFloat(oldValue) + 1;
  } else {
    // Don't allow decrementing below zero
    if (oldValue > 0) {
      newVal = parseFloat(oldValue) - 1;
    }
  }

  $button.parent().find('input').val(newVal);
});


$('#select-food').on('click', () => {
  changeIndex(4);
});

$('#skip-food').on('click', () => {
  changeIndex(6);
  if (parseInt($('#customer_count').val()) <= parseInt($('#max-capacity').val())) {
    $('.summary-customer-time-wish').hide();
  }
  else {
    $('#summary-time').hide();
  }
});

$('#select-alacarte').on('click', () => {
  changeIndex(4);
});

$('#add-single-dishes-form').on('submit', (e) => {
  e.preventDefault();
  setDataToLocalStorage();
  changeIndex(5);
  $([document.documentElement, document.body]).animate({
    scrollTop: $('#step-5').offset().top - 100,
  }, 1000);
});

$('#add-drinks-form').on('submit', (e) => {
  e.preventDefault();
  setDataToLocalStorage();
  refreshCart();

  changeIndex(6);
  if (parseInt($('#customer_count').val()) <= parseInt($('#max-capacity').val())) {
    $('.summary-customer-time-wish').hide();
  }
  else {
    $('#summary-time').hide();
  }
});

$('#summary-form').on('submit', (e) => {
  e.preventDefault();
  setDataToLocalStorageFromCart();
  refreshCart();
});

//When clicking edit time form button, change input max and min according to customer count for validation
$('#submit-edit-location-and-time-form').on('click', function () {
  const c_max = $('#max-capacity').val();
  const c_count = $('#customer_count').val();
  const c_count_original = $('#order-original-customer-count').val();

  $('#customer_count').attr('max', '100');
  $('#customer_count').attr('min', '1');

  console.log(c_max);
  console.log(c_count);

  // if(parseInt(c_max) < parseInt(c_count) && parseInt(c_max) < parseInt(c_count_original)) {
  if (parseInt(c_max) < parseInt(c_count_original)) {
    $('#customer_count').attr('min', c_max);
    $('#customer_count').attr('max', '100');
  }
  else {
    $('#customer_count').attr('min', '1');
    $('#customer_count').attr('max', c_max);
  }
});

$('#edit-location-and-time-form').on('submit', (e) => {
  e.preventDefault();
  $('#step-edit-date').addClass('loading');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const r_time = $('#reservation_time').val();
  const r_date = $('#reservation_date').val();
  const c_count = $('#customer_count').val();
  const order_id = urlParams.get('edit_order');
  const wp_nonce = urlParams.get('_wpnonce');

  $.ajax({
    // eslint-disable-next-line
    url: wpAjax.ajaxUrl,
    data: { action: 'harald_edit_date', order_id, r_date, r_time, wp_nonce, c_count },
    type: 'post',
    success: function () {
      $('#location-and-time-container').removeClass('hidden');
      $('#edit-location-and-time-form').addClass('hidden');
      $([document.documentElement, document.body]).animate({
        scrollTop: $('#location-and-time-container').offset().top - 100,
      }, 1000);
    },
    error: function (err) {
      console.warn(err);
      alert('Virhe päivittäessä ajankohtaa. Ota yhteyttä ravintolaan.');
    },
    complete: function () {
      $('#step-edit-date').removeClass('loading');
    },
  });
});

/**
 * Change order products
 */
/* eslint-disable */
$('#edit-order-products-form').on('submit', (e) => {
  e.preventDefault();
  var menuNotes = $('.menu-notes').map(function () {
    if (this.value) {
      return this.value;
    }
  }).get().join('\n');
  $('#step-edit-products').addClass('loading');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const order_id = urlParams.get('edit_order');
  const wp_nonce = urlParams.get('_wpnonce');
  var order_products = [];
  var selected_type = 'dishes';
  $('#edit-order-products-form .number-input-container input').each(function () {
    var product_id = null;
    var product_amount = null;

    if ($(this).hasClass('input-variable-product')) {
      product_amount = $(this).val();
      product_id = $(this).data('variation-id');
      order_products.push([product_id, product_amount]);
    }
    else if ($(this).hasClass('input-single-product')) {
      product_amount = $(this).val();
      product_id = $(this).data('product-id');
      order_products.push([product_id, product_amount]);
    }
  });

  $.ajax({
    // eslint-disable-next-line
    url: wpAjax.ajaxUrl,
    data: { action: 'harald_edit_products', order_id, wp_nonce, order_products, selected_type, menuNotes },
    type: 'post',
    success: function (res) {
      $('#products-updated-container').removeClass('hidden');
      $('#edit-order-products-form').addClass('hidden');
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#products-updated-container").offset().top - 100
      }, 1000);
    },
    error: function (err) {
      console.warn(err);
    },
    complete: function () {
      $('#step-edit-products').removeClass('loading');
    },
  });

});

$('#edit-order-drinks-form').on('submit', (e) => {
  e.preventDefault();
  var menuNotes = $('.menu-notes').map(function () {
    if (this.value) {
      return this.value;
    }
  }).get().join('\n');
  $('#step-edit-drinks').addClass('loading');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const order_id = urlParams.get('edit_order');
  const wp_nonce = urlParams.get('_wpnonce');
  var order_products = [];
  var selected_type = 'drinks';
  $('#edit-order-drinks-form .number-input-container input').each(function () {
    var product_id = null;
    var product_amount = null;

    if ($(this).hasClass('input-variable-product')) {
      product_amount = $(this).val();
      product_id = $(this).data('variation-id');
      order_products.push([product_id, product_amount]);
    }
    else if ($(this).hasClass('input-single-product')) {
      product_amount = $(this).val();
      product_id = $(this).data('product-id');
      order_products.push([product_id, product_amount]);
    }
  });

  $.ajax({
    // eslint-disable-next-line
    url: wpAjax.ajaxUrl,
    data: { action: 'harald_edit_products', order_id, wp_nonce, order_products, selected_type, menuNotes },
    type: 'post',
    success: function (res) {
      $('#drinks-updated-container').removeClass('hidden');
      $('#edit-order-drinks-form').addClass('hidden');
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#drinks-updated-container").offset().top - 100
      }, 1000);
    },
    error: function (err) {
      console.warn(err);
    },
    complete: function () {
      $('#step-edit-drinks').removeClass('loading');
    },
  });

});

/* eslint-enable */

/**
 * Change order drinks
 */
$('#edit-order-drinks-form').on('submit', (e) => {
  e.preventDefault();
  $('#step-edit-drinks').addClass('loading');
});

/**
 * Choose menu
 */
$('.choose-menu').on('click', (e) => {
  $('.note').addClass('hidden');
  $(e.target).closest('.form-tab').find(':input[type="number"]').val(0);
  //$( '.form-tab' ).find(':input[type="number"]').val(0);
  $(e.target).closest('.form-tab').find('textarea').val('');
  $(e.target).closest('.form-tab').find('.choose-menu').removeClass('hidden');
  $(e.target).parents('.form-tab-edit').find('.choose-menu').removeClass('hidden');
  //$('.choose-menu').removeClass('hidden');
  $(e.target).closest('.choose-menu').addClass('hidden');
  $(e.target).closest('.single-product').removeClass('hidden');
  $(e.target).closest('.form-tab').find('.input-container').addClass('hidden');
  $(e.target).closest('.single-product').find('.input-container').removeClass('hidden');
  $(e.target).closest('.single-product').find('.note').removeClass('hidden');

  if ($(e.target).hasClass('is-simple-product')) {
    var customerCount = $('#customer_count').val();
    var product_id = $(e.target).data('product-id');
    //console.log('tiuote id: ' + product_id);
    //console.log('asiakkaita: ' + customerCount);
    //$( this ).closest( '.form-tab' ).find(':input[type="number"]').val(customerCount);
    //$( e.target ).closest( '.form-tab' ).find(':input[type="number"]').val(customerCount);
    $('input#input-single-product-' + product_id).val(customerCount);
  }
});

// Choose menu (food)
$('#step-4 .choose-menu').on('click', (e) => {
  $('#step-4 .product-excerpt').hide();
  $(e.target).parents('.single-product').find('.product-excerpt').show();
  let changeText = $('#string-change-menu').data('text');
  $('#step-4 .choose-menu').text(changeText);

  let productId = $(e.target).data('product-id');
  $('html, body').animate({ scrollTop: $('#product-' + productId).offset().top - 100 }, 500);
});

// Choose menu (drinks)
$('#step-5 .choose-menu').on('click', (e) => {
  $('#step-5 .product-excerpt').hide();
  $(e.target).parents('.single-product').find('.product-excerpt').show();
  let changeText = $('#string-change-menu').data('text');
  $('#step-5 .choose-menu').text(changeText);

  let productId = $(e.target).data('product-id');
  $('html, body').animate({ scrollTop: $('#product-' + productId).offset().top - 100 }, 500);
});

// Edit orders (food)
$('#step-edit-products .choose-menu').on('click', (e) => {
  $('#step-edit-products .product-excerpt').hide();
  $(e.target).parents('.single-product').find('.product-excerpt').show();
  $('#step-edit-products .input-container').hide();
  $(e.target).parents('.single-product').find('.input-container').show();
  let changeText = $('#string-change-menu').data('text');
  $('#step-edit-products .choose-menu').text(changeText);

  $('#step-edit-products input.input-variable-product').val(0);
  $('#step-edit-products input.input-single-product').val(0);

  let productId = $(e.target).data('product-id');
  $('html, body').animate({ scrollTop: $('#product-' + productId).offset().top - 100 }, 500);
});

// Edit orders (drinks)
$('#step-edit-drinks .choose-menu').on('click', (e) => {
  $('#step-edit-drinks .product-excerpt').hide();
  $(e.target).parents('.single-product').find('.product-excerpt').show();
  $('#step-edit-drinks .input-container').hide();
  $(e.target).parents('.single-product').find('.input-container').show();
  let changeText = $('#string-change-menu').data('text');
  $('#step-edit-drinks .choose-menu').text(changeText);

  $('#step-edit-drinks input.input-variable-product').val(0);
  $('#step-edit-drinks input.input-single-product').val(0);

  let productId = $(e.target).data('product-id');
  $('html, body').animate({ scrollTop: $('#product-' + productId).offset().top - 100 }, 500);
});


const setDataToLocalStorageFromCart = () => {
  let products = [];
  $('#summary-form').serializeArray().forEach(product => {
    products.push(product);
  });
  window.localStorage.setItem('harald_products', JSON.stringify(products));
};

const setDataToLocalStorage = () => {
  //get form data
  let products = [];
  $('#add-single-dishes-form').serializeArray().forEach(product => {
    products.push(product);
  });

  $('#add-drinks-form').serializeArray().forEach(product => {
    products.push(product);
  });
  //save form data to localstorage
  window.localStorage.setItem('harald_products', JSON.stringify(products));
};

//creates items array from localstorage items

const getItems = () => {
  const products = JSON.parse(window.localStorage.getItem('harald_products'));
  let items = [];
  products.forEach(product => {
    if (product.value > 0) {
      items.push({ id: product.name, quantity: product.value });
    }
  });
  return items;
};

/* eslint-disable */
const refreshCart = () => {
  const products = getItems();
  const data = { products, action: 'harald_add_to_cart' }
  jQuery.post(
    wpAjax.ajaxUrl,
    data,
    () => {
      setCartHtml();
    })
};

const setCartHtml = () => {
  $("#summary-form").html('<i class="fas fa-circle-notch fa-spin"></i>');
  jQuery.post(
    wpAjax.ajaxUrl,
    { action: "harald_get_cart_html" },
    (res) => {
      $("#summary-form").html(res);
    })
};

export const changeIndex = (index) => {
  $('.form-tab').hide();
  $(`#step-${index}`).addClass('animate__animated animate__fadeIn');
  $(`#step-${index}`).show();
  $([document.documentElement, document.body]).animate({
    scrollTop: $(`#step-${index}`).offset().top - 100,
  }, 1000);
};

export default {

}
/* eslint-enable */




// WEBPACK FOOTER //
// ./scripts/util/harald-form-common.js